<template>
  <div class="sidebar">
    <div class="sidebar__header">
      <v-tabs v-model="isProfile">
        <v-tab>Profile</v-tab>
        <v-tab>Navigation</v-tab>
      </v-tabs>
    </div>

    <div class="sidebar__body lead-info" :class="{ 'p-0': isProfile }">
      <div v-if="isProfile">
        <v-stepper v-model="defineStep" vertical>
          <v-stepper-step
            role="button"
            :complete="defineStep > step.index"
            :step="step.index"
            @click="onStepClick(step.type)"
            v-for="(step, k) in steps"
            :key="k"
          >
            {{ step.body }}
          </v-stepper-step>
        </v-stepper>
      </div>

      <div v-else>
        <!--   name   -->

        <AgentSidebarItem
          @update="lead.fullname = $event"
          :value="lead.fullname"
          name="Name"
        />

        <!--   phone   -->

        <div class="lead-info__item">
          <div class="lead-info__label">Phone</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.phone }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   dob  -->

        <div class="lead-info__item">
          <div class="lead-info__label">DOB</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ format(new Date(lead.birth_date), 'MM-dd-yyyy') }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   age  -->

        <div class="lead-info__item">
          <div class="lead-info__label">Age</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.age }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   gender  -->

        <div class="lead-info__item">
          <div class="lead-info__label">Gender</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.gender }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   height  -->

        <div class="lead-info__item">
          <div class="lead-info__label">Height</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.height }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   weight  -->

        <div class="lead-info__item">
          <div class="lead-info__label">Weight</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.weight }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   BMI  -->

        <div class="lead-info__item">
          <div class="lead-info__label">BMI</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.bmi }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="my-4" />

        <!--   city  -->

        <div class="lead-info__item">
          <div class="lead-info__label">City</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.city }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   state  -->

        <div class="lead-info__item">
          <div class="lead-info__label">State</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.state }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>

        <!--   zip  -->

        <div class="lead-info__item">
          <div class="lead-info__label">Zip</div>
          <div class="lead-info__actions">
            <span class="font-weight-medium">
              {{ lead.zipcode }}
            </span>

            <v-btn text icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import AgentSidebarItem from '@/components/lead/AgentSidebarItem';
import { mapGetters } from 'vuex';

export default {
  name: 'AgentSidebar',
  components: { AgentSidebarItem },
  //Todo make a sidebar field composition
  props: {
    lead: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      steps: 'plates/stepsFlow',
      step: 'plates/step',
    }),
    defineStep() {
      const { index } = this.steps.find((i) => i.type === this.step);
      return index;
    },
  },
  data() {
    return {
      initialState: {},
      isProfile: false,
    };
  },
  mounted() {
    this.initialState = { ...this.lead };
  },
  methods: {
    format,
    update(payload) {
      console.log(payload);
    },
    onStepClick(type) {
      this.$store.commit('plates/setStep', type);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

  &__header {
    padding: 15px 20px;
    //border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__body {
    padding: 15px 20px;
  }
}

.lead-info {
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.p-0 {
  padding: 0;

  .v-stepper {
    box-shadow: none;
    padding: 0;

    &__step {
      padding: 10px 15px 10px;
      font-size: 14px;
    }
  }
}
</style>